<template lang="pug">
.price-tier
  template(v-if="!item.isChild && !item.isParent")
    treatment-price-tier-dropdown(v-if="isEditable" :item="item" @dropdownOpenClosed="$emit('dropdownOpenClosed', $event)" @changed="$emit('changed')")
    div.clickable(v-else-if="item.priceTier")
      span.font-medium.danger500--text(v-if="item.error") {{ item.priceTier.name }}
      span(v-else) {{ item.priceTier.name }}
</template>

<script>
import TreatmentPriceTierDropdown from '@/components/clinic/consultation/treatments/treatmentTableItems/TreatmentPriceTierDropdown.vue'

export default {
  components: {
    TreatmentPriceTierDropdown,
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isEditable () {
      if (this.item.editable && this.item.productItem) {
        if (this.item.productItem.type === 'documents') {
          return this.item.productItem.document_template.price_tier_enabled
        }
        return true
      }
      return false
    }
  },
};
</script>

<style lang="scss" scoped>
</style>